/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getGatedContentCheckedFields } from 'selectors';
import { useGetGatedContentQuery } from 'store/api/version-api.slice';
import { setGatedContent } from 'store/slices/gated.slice';

import GatedContentDialog from './GatedContentDialog';
import { styles } from './styles';

const GatedContentView = () => {
	const [formOpen, setFormOpen] = useState(false);

	const dispatch = useDispatch();

	const { data: gatedContent = {} } = useGetGatedContentQuery();
	const gatedContentCheckedFields = useSelector(getGatedContentCheckedFields);

	useEffect(() => {
		if (Object.keys(gatedContent).length) {
			dispatch(setGatedContent(gatedContent));
		}
	}, [gatedContent, dispatch]);

	const toggleMemberForm = () => setFormOpen(prev => !prev);

	const handleChange = memberTypeFields => {
		// prep new list
		const checkedFields = [];
		// loop over fields
		memberTypeFields.forEach(field => {
			// if field is checked
			if (field.checked) {
				const checkField = {
					code: `<div class="membercenter_cms_check" id="${field.id}"></div>`,
					memberTypeId: field.id
				};
				// string my shit and push to list
				checkedFields.push(checkField);
			}
		});

		// copy old state:
		const newScriptCode = { ...gatedContent };

		newScriptCode.checked_fields = checkedFields;

		dispatch(setGatedContent(newScriptCode));
	};

	const checkedFieds = useMemo(() => {
		return gatedContentCheckedFields?.map(field => field.code) ?? [];
	}, [gatedContentCheckedFields]);

	const handleGenerate = () => {
		toggleMemberForm();
	};

	return (
		<Box sx={styles.root}>
			<Box>
				<Paper elevation={2}>
					<Toolbar>
						<Typography component={'span'} variant="h6" color="primary" sx={styles.title}>
							GATED CONTENT
						</Typography>
					</Toolbar>
					<Divider />
					<Box sx={styles.content}>
						<Box key={`member-form-0`} style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography variant={'h6'} component={'span'}>
								Embeddable Code:
							</Typography>
							<Typography component={'pre'} sx={styles.code_block}>
								{[gatedContent.script_code, ...checkedFieds].map((codeline, idx) => (
									<code key={idx}>{codeline}</code>
								))}
							</Typography>
						</Box>
						<Box
							sx={{
								padding: 8,
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}
						>
							<Button
								color="primary"
								variant={'contained'}
								style={{ marginBottom: 8 }}
								onClick={toggleMemberForm}
							>
								Gated Content
							</Button>
						</Box>
					</Box>
				</Paper>
			</Box>
			<GatedContentDialog
				formOpen={formOpen}
				handleChange={handleChange}
				handleGenerate={handleGenerate}
				toggleMemberForm={toggleMemberForm}
			/>
		</Box>
	);
};

export default GatedContentView;
